import { render, staticRenderFns } from "./AddedToCartNotification.vue?vue&type=template&id=4c8afff9&scoped=true&"
import script from "./AddedToCartNotification.vue?vue&type=script&lang=js&"
export * from "./AddedToCartNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddedToCartNotification.vue?vue&type=style&index=0&id=4c8afff9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8afff9",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fadded-to-cart-notification%2FAddedToCartNotification.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports